import React from "react";
import { Skeleton } from "components";
import { Col, Row } from "react-bootstrap";

export default function AboutCardsSkeleton() {
  return (
    <Row>
      {Array(4)
        .fill((i) => i)
        .map((item, index) => (
          <Col key={index} xl={3} lg={6} md={6} sm={6} xs={12} className="p-0">
            {/* about us card */}
            <div
              className={`mx-1 mb-2 about_us_card bg-white border border-light3 border-2 rounded-3 py-4`}
            >
              <Row>
                {/* about us card image */}
                <Col xs={12} className="text-center">
                  <Skeleton count={1} height={60} width={60} />
                </Col>
                <Col xs={12} className="text-center mt-2">
                  <Skeleton count={1} height={10} width={"80%"} />
                </Col>
                <Col xs={12} className="text-center">
                  {/* about us card name*/}
                  <Skeleton count={1} height={10} width={"80%"} />
                </Col>
              </Row>
            </div>
          </Col>
        ))}
    </Row>
  );
}
